import React from 'react';
import PropTypes from 'prop-types';
import Button from '@ids/button';
import '../../../stylesheets/checkAndSuppliesResourceCenter.scss';
import '../../../stylesheets/main.scss';
import ResourceCenterFooter from '../Common/ResourceCenterFooter';
import { backToCategory, toPascalCase } from '../Util/CommonUtils';

function ResourceReadMoreContent(props) {
  const content = props.contentVariable;
  return (
    <div className="supplies-resource-support">
      <div className="container-center-lg">
        <div className="margin-main-section">
          <div className="row">
            <div className="col-lg-6">
              <a href="/resources" className="display-flex-reverse">
                <Button className="back-to-center">Back to Resource Center</Button>
              </a>
            </div>
            <div className="col-lg-5 margin-top-30px">
              <a href={backToCategory(content.smallHeader)} className="backToCheck">
                {`Back to ${toPascalCase(content.smallHeader)}`}
              </a>
            </div>
          </div>
          <div className="padding-side-160">
            <p className="smallHeading text-align-center">{content.smallHeader}</p>
            <br />
            <h1 className="largeHeading margin-bottom-55px text-align-center padding-side-50">
              {content.title}
            </h1>
            <div className="para">
              {content.description && (
                <p
                  className={`font-size-20-regular ${
                    content.descriptionBottomMargin
                      ? content.descriptionBottomMargin
                      : 'margin-bottom-56px'
                  } `}
                >
                  {content.description}
                </p>
              )}
              {content.image && (
                <div className="image">
                  <img src={content.image} alt="..." />
                </div>
              )}
              {content.Topic &&
                content.Topic.map((data) => {
                  return (
                    <div className={data.noBottomMargin ? '' : 'margin-bottom-33px'}>
                      {data.heading && (
                        <>
                          <h2
                            className={
                              content.headingBottomSpace
                                ? 'font-34px font-wgt-700 padding-bottom-0px'
                                : 'font-34px font-wgt-700 padding-bottom-15px'
                            }
                          >
                            {data.heading}
                          </h2>
                        </>
                      )}

                      {data.para && (
                        <p
                          className={`font-size-20-regular ${
                            data.bottomPadding ? data.bottomPadding : 'padding-bottom-20px'
                          } `}
                        >
                          {data.para}
                        </p>
                      )}
                      {data.headingSubContent && (
                        <div className="headingSubContent">
                          <p>{data.headingSubContent}</p>
                        </div>
                      )}
                      {data.quote && (
                        <div className="padding-left-40px">
                          <p className="font-italic">{data.quote}</p>

                          <span className="line-heigth-3">{data.author}</span>
                        </div>
                      )}

                      {data.subHeadings &&
                        data.subHeadings.map((ele) => {
                          return (
                            <div className={content.noTopicSpace ? '' : 'padding-left-40px'}>
                              {ele.subHeading && (
                                <h3 className="font-20px font-wgt-600">{ele.subHeading}</h3>
                              )}
                              {ele.subHeadingDetails && (
                                <p className="font-20px">{ele.subHeadingDetails}</p>
                              )}
                              <br />
                            </div>
                          );
                        })}
                    </div>
                  );
                })}
              {content.notes &&
                content.notes.map((noteData) => {
                  return <p className="font-size-20-regular margin-bottom-68px">{noteData.note}</p>;
                })}
            </div>
          </div>
        </div>
      </div>
      <ResourceCenterFooter />
    </div>
  );
}
ResourceReadMoreContent.propTypes = {
  contentVariable: PropTypes.objectOf(Object),
};
export default ResourceReadMoreContent;
